import { userActionList } from '../action-lists';

const userListState = {
  users: [],
  pagination: {
    totalCount: 0,
    rowsPerPage: 10,
    page: 0
  }
};

export default function userListReducer(state = userListState, action) {
  switch (action.type) {
    case userActionList.updateUsers: {
      const { data, pagination } = action.payload;

      return {
        ...state,
        users: data,
        pagination: {
          totalCount: pagination.totalCount,
          rowsPerPage: pagination.rows,
          page: pagination.currentPage - 1,
        }
      };
    }

    default: return state;
  }
}
